export enum DragElementEnum {
  NOTHING,
  FOLDER,
  WIDGET,
  COLLECTION,
  NOT_ALLOWED
}
